@if (isButtonVisible && appService.selectedClient?.hasFeature(Features.Messaging)) {
<p-overlaybadge [value]="undefined" [badgeDisabled]="!unreadCount" severity="danger">
    <p-button label="Messagerie" icon="pi pi-comments" [outlined]="true" [rounded]="true" (onClick)="openConversationsView()"></p-button>
</p-overlaybadge>
}